<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> گزارش ورود و خروج </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- فیلتر جستجو -->

    <form class="row gx-2 gy-3" [formGroup]="mdl_Search">

        <!-- از تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> از تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />

            </ng-persian-datepicker>

        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> تا تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input formControlName="strEDate" placeholder="از تاریخ" class="form-control text-end" />

            </ng-persian-datepicker>

        </div>

        <!-- پرسنل / دانش آموز -->

        <div class="col-12 col-md-3 position-relative">

            <label class="mb-2 text-muted"> پرسنل / دانش آموز </label>

            <select class="form-select p-2" formControlName="iPassenger">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_Passenger" [value]="item.iPassenger">

                    {{ item.strPassenger_FullName }}

                </option>

            </select>

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-1 position-relative border border-2 b-transparent">

            <button class="btn btn-primary w-100" (click)="search_Trip()">

                جستجو

            </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-success w-100" (click)="exportExcel('Export_Excel')">

                خروجی اکسل

            </button>

        </div>

    </form>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2">

        <div class="row gx-0 gy-2 gy-md-0">

            <div class="col-12">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm
                    (keyup)="filter_list($event.target)">

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 220px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="">

                        <th class="text-center col-1"> # </th>

                        <th class="text-center col-1"> عملیات </th>

                        <th class="text-center"> تاریخ </th>

                        <th class="text-center"> پرسنل </th>

                        <th class="text-center"> ساعت ورود </th>

                        <th class="text-center"> ساعت خروج </th>

                        <th class="text-center"> مت حضور </th>

                        <th class="text-center"> توضیحات </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Request;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <th class="">

                            <i class="fa fa-pencil-square fa-lg pointer" title="ویرایش" (click)="openEdit(item)"></i>

                        </th>

                        <td> {{ item.strDate | faNum }} </td>

                        <td> {{ item.strPassenger_FullName | faNum }} </td>

                        <td> {{ item.strTime | faNum }} </td>

                        <td> {{ item.strETime | faNum }} </td>

                        <td> {{ item.DurationAttendance | faNum }} </td>

                        <td> {{ item.strComment | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

    <!-- مدال ویرایش -->

    <div class="modal fade" id="entryExit_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

        <div class="modal-dialog">

            <div class="modal-content dirI">

                <div class="modal-header dirI">

                    <h5 class="modal-title" id="exampleModalLabel"> ویرایش </h5>

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                </div>

                <div class="modal-body">

                    <div [formGroup]="mdl_Absence" class="w-100 row gx-0 gy-0">

                        <!-- ساعت شروع -->

                        <div class="position-relative col-12 col-md-6 p-2">

                            <label class="mb-2 text-muted" style="z-index: 10;"> ساعت شروع </label>

                            <div class="input-group clockpicker">

                                <input type="text" class="form-control p-2 text-center" id="strTime"
                                    formControlName="strTime">

                                <span class="input-group-addon">

                                    <span class="glyphicon glyphicon-time"></span>

                                </span>

                            </div>

                        </div>

                        <!-- ساعت پایان -->

                        <div class="position-relative col-12 col-md-6 p-2">

                            <label class="mb-2 text-muted" style="z-index: 10;"> ساعت پایان </label>

                            <div class="input-group clockpicker">

                                <input type="text" class="form-control p-2 text-center" id="strETime"
                                    formControlName="strETime">

                                <span class="input-group-addon">

                                    <span class="glyphicon glyphicon-time"></span>

                                </span>

                            </div>

                        </div>

                        <!-- توضیحات -->

                        <div class="position-relative col-12 p-2">

                            <label class="mb-2 text-muted"> توضیحات </label>

                            <textarea style="height: 100px;resize: none;" class="form-control" formControlName="strComment"></textarea>

                        </div>

                    </div>

                </div>

                <div class="modal-footer d-flex justify-content-start">

                    <button class="btn btn-primary" (click)="editEntry()">

                        &nbsp; &nbsp; ویرایش &nbsp; &nbsp;

                    </button>

                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                        &nbsp; بستن &nbsp;

                    </button>

                </div>

            </div>

        </div>

    </div>

</main>